import axios, { AxiosRequestConfig } from 'axios';

import { ParentKids } from '../types/ParentKids';
import { DataResponse, PagedResponse } from '../types/api';

const URL = '/v2/parent-kids';

class ParentKidsService {
  static create(
    data: ParentKids,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ParentKids>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: ParentKids,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ParentKids>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }

  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<ParentKids>> {
    return axios.get(URL, config);
  }
}

export { ParentKidsService };
